(function () {

  window.dataLayer = window.dataLayer || [];

  const trackedProducts = new Set();
  const trackedViewItems = new Set();
  // 用于追踪当前页面最近一次交互的商品上下文（解决 Quick View 严谨性）
  let lastInteractedContext = null;

  function getProductData(el) {

    return {
      items: {
        item_id: el.dataset.itemId || el.dataset.itemIdView || el.dataset.itemIdCart,
        item_name: el.dataset.itemName,
        item_sku: el.dataset.itemSku,
        price: parseFloat(el.dataset.itemPrice || 0),
        item_category: el.dataset.itemCategory,
        index: parseInt(el.dataset.itemIndex || 0)
      },
      item_list_name: el.dataset.itemListName || "unknown_list",
    };

  }
  // 1.商品列表曝光
  function pushExposure(el) {

    const id = el.dataset.itemId;
    const list = el.dataset.itemListName || "unknown_list";
    const key = id + "_" + list;

    if (trackedProducts.has(key)) return;

    trackedProducts.add(key);

    const item = getProductData(el);

    dataLayer.push({
      event: "view_item_list",
      ecommerce: {
        item_list_name: item.item_list_name,
        items: [item.items]
      }
    });

  }

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        pushExposure(entry.target);

        observer.unobserve(entry.target);

      }

    });

  }, {
    // threshold: 0.5
    threshold: 0.3,
    rootMargin: "0px 0px -20% 0px"
  });

  function observeProducts(root = document) {

    const products = root.querySelectorAll("[data-item-id]");
    productDetailItem = []
    products.forEach(el => {

      observer.observe(el);

    });

  }

  function initExposure() {

    observeProducts();

    const mutationObserver = new MutationObserver((mutations) => {

      mutations.forEach(mutation => {

        mutation.addedNodes.forEach(node => {

          if (!(node instanceof HTMLElement)) return;

          if (node.dataset && node.dataset.itemId) {

            observer.observe(node);

          } else {

            observeProducts(node);

          }

        });

      });

    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

  }
  // 2.商品点击进入详情
  function trackClick(event) {
    const product = event.target.closest("[data-item-id]") || event.target.closest("[data-item-id-cart]");
    if (!product) return;
    
    const item = getProductData(product);
    // 记录当前点击的上下文，供 Quick View 或当前页加购使用
    lastInteractedContext = {
      id: item.items.item_id,
      listName: item.item_list_name
    };

    const link = event.target.closest("a");
    if (!link) return;


    if (link && link.href.includes('/products/')) {
      // 方案一：URL 传参
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('item_list_name', item.item_list_name);
      link.href = url.toString();
    }
    
    dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_name: item.item_list_name,
        items: [item.items]
      }
    });

  }

  function initClick() {

    document.addEventListener("click", trackClick, true);
    // 帮助中心
    document.addEventListener('click', function(e) {
      var el = e.target;

      var item = el.closest('.help_item');
      if (!item) return;

      var title = item.querySelector('.help_item_title');
      if (!title) return;

      dataLayer.push({
        event: 'help_center_click',
        button_name: title.innerText.trim()
      });
    }, true);
    // FAQ中心
    document.addEventListener('click', function(e) {
      var el = e.target;
      if (!el) return;

      // 向上查找 .ques_title（不用 closest，保证稳定）
      var node = el;
      while (node && node !== document) {
        if (node.classList && node.classList.contains('ques_title')) {
          break;
        }
        node = node.parentElement;
      }

      var text = '';

      if (node && node !== document) {
        text = node.innerText ? node.innerText.trim() : '';
      }

      // 降级
      if (!text) return;

      dataLayer.push({
        event: 'help_center_question_click',
        question_text: text
      });
    }, true);

  }

  // 3.浏览商品详情页
  function pushViewItem(item, type, listName = "unknown_list") {

    // const id = el.dataset.itemId;
    const id = item.item_id
    if (!id) return;

    if (trackedViewItems.has(id + "_" + type)) return;

    trackedViewItems.add(id + "_" + type);

    dataLayer.push({
      event: "view_item",
      view_type: type,
      ecommerce: {
        currency: item.currency,
        value: item.price,
        item_list_name: listName,
        items: [{
          item_id: item.item_id,
          item_sku: item.item_sku || '',
          item_name: item.item_name,
          price: item.price,
          item_category: item.item_category,
        }]
      }
    });

  }
  // 记录商品详情页来源
  let pageLevelContext = {
    listName: "direct_visit",
    itemId: null
  };
  function initProductDetail() {

    if (location.pathname.includes("/products/")) {

      const product = document.querySelector("[data-item-id]");

      // --- 修改：从 URL 获取参数 ---
      const urlParams = new URLSearchParams(window.location.search);
      const listNameFromUrl = urlParams.get('item_list_name');
      // 如果 URL 里有值，更新页面级上下文
      if (listNameFromUrl) {
        pageLevelContext.listName = listNameFromUrl;
      }
      // ---------------------------

      if (product) {
        pageLevelContext.itemId = window.productData.id.toString();
        const productData = {
          item_id: window.productData.id,
          item_name: window.productData.name,
          price: window.productData.price,
          item_category: window.productData.category,
          currency: window.productData.currency,
          item_sku: window.productData.sku
        }
        pushViewItem(productData, "product_detail", pageLevelContext.listName);

        // 抹除 URL 参数，保证刷新后消失
        if (urlParams.has('item_list_name')) {
          urlParams.delete('item_list_name');
          const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
          window.history.replaceState(null, '', newUrl);
        }
      }

    }

  }

  function initQuickViewObserver() {

    const quickObserver = new MutationObserver((mutations) => {

      mutations.forEach(mutation => {

        mutation.addedNodes.forEach(node => {

          if (!(node instanceof HTMLElement)) return;

          const quickProduct = node.querySelector?.(".quick-buy-product__info");

          if (quickProduct) {
            const dataset = quickProduct.dataset;
            // 尝试获取item_list_name
            const currentId = dataset.itemIdView;
            // 严谨匹配：只有当最近一次点击的 ID 和 弹窗 ID 一致时，才使用那个 listName
            let listName = "quick_view_general";
            if (lastInteractedContext && lastInteractedContext.id === currentId) {
              listName = lastInteractedContext.listName;
            }

            const productData = {
              item_id: dataset.itemIdView,
              item_name: dataset.itemName,
              price: dataset.itemPrice,
              item_category: dataset.itemCategory,
              currency: dataset.currency,
              item_sku: dataset.itemSku,
            }
            pushViewItem(productData, "quick_view", listName);

          }

        });

      });

    });

    quickObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

  }

  // 4.加入购物车埋点
  /**
   * 格式化价格：将 Shopify 的分转换为元
   * @param {number} priceInCents - Shopify 价格（分）
   * @returns {number} 格式化后的价格（元）
   */
  function formatPrice(priceInCents) {
    if (typeof priceInCents !== 'number') return 0;
    return Number((priceInCents / 100).toFixed(2));
  }

  /**
   * 解析本次加购请求体中的变体 ID 和新增数量。
   * 兼容普通商品表单 FormData、URLSearchParams、JSON 单商品以及 JSON 批量 items。
   * 注意：Shopify 响应中的 quantity 可能是购物车合并后的累计数量，不能代表本次新增数量。
   * @param {FormData|URLSearchParams|string} body - /cart/add.js 的请求体
   * @returns {Array<{variantId: string, quantity: number}>} 本次请求的商品与新增数量
   */
  function parseAddRequestBody(body) {
    if (!body) return [];

    // 统一变体 ID 类型，并将缺失、无效或小于 1 的数量安全兜底为 1。
    const normalizeItem = (id, quantity) => {
      if (id === null || id === undefined || id === '') return null;

      const parsedQuantity = Number(quantity ?? 1);

      return {
        variantId: String(id),
        quantity: Number.isFinite(parsedQuantity) && parsedQuantity > 0
          ? Math.max(1, Math.trunc(parsedQuantity))
          : 1
      };
    };

    // 解析普通 id/quantity，以及 items[0][id]/items[0][quantity] 形式的批量表单字段。
    const parseParams = (params) => {
      const singleItem = normalizeItem(params.get('id'), params.get('quantity'));
      if (singleItem) return [singleItem];

      const indexedItems = [];

      params.forEach((value, key) => {
        const match = key.match(/^items\[(\d+)]\[(id|quantity)]$/);
        if (!match) return;

        const index = Number(match[1]);
        const field = match[2];
        indexedItems[index] = indexedItems[index] || {};
        indexedItems[index][field] = value;
      });

      return indexedItems
        .map(item => item && normalizeItem(item.id, item.quantity))
        .filter(Boolean);
    };

    if (body instanceof FormData || body instanceof URLSearchParams) {
      return parseParams(body);
    }

    if (typeof body === 'string') {
      try {
        const data = JSON.parse(body);
        const items = Array.isArray(data.items) ? data.items : [data];

        return items
          .map(item => item && normalizeItem(item.id || item.variant_id, item.quantity))
          .filter(Boolean);
      } catch (_) {
        return parseParams(new URLSearchParams(body));
      }
    }

    return [];
  }

  /**
   * 从 fetch/XHR 接收的不同资源类型中提取请求 URL。
   * 除字符串外，同时兼容 URL 对象和 Request 对象，避免漏掉非字符串形式的加购请求。
   * @param {string|URL|Request} resource - 请求资源
   * @returns {string} 可用于判断接口路径的 URL 字符串
   */
  function getRequestUrl(resource) {
    if (typeof resource === 'string') return resource;
    if (resource instanceof URL) return resource.href;
    if (typeof Request !== 'undefined' && resource instanceof Request) return resource.url;
    return '';
  }

  /**
   * 获取 Fetch 加购请求中的商品和本次新增数量。
   * 优先读取 options.body；当调用方式为 fetch(Request) 时，通过克隆 Request 读取请求体，
   * 避免消费原始请求流而影响真实的加购请求。
   * @param {string|URL|Request} resource - fetch 的第一个参数
   * @param {Object} options - fetch 的请求配置
   * @returns {Promise<Array<{variantId: string, quantity: number}>>} 本次请求的商品与新增数量
   */
  async function getFetchRequestedItems(resource, options) {
    if (options?.body) return parseAddRequestBody(options.body);

    if (typeof Request !== 'undefined' && resource instanceof Request) {
      try {
        const request = resource.clone();
        const contentType = request.headers.get('content-type') || '';

        if (
          contentType.includes('multipart/form-data') ||
          contentType.includes('application/x-www-form-urlencoded')
        ) {
          return parseAddRequestBody(await request.formData());
        }

        return parseAddRequestBody(await request.text());
      } catch (_) {
        return [];
      }
    }

    return [];
  }

  /**
   * 将 /cart/add.js 响应商品与请求商品进行匹配。
   * 优先按数组下标匹配批量加购，顺序不一致时再按 variant ID 兜底匹配。
   * @param {Object} responseItem - /cart/add.js 返回的商品
   * @param {number} responseIndex - 商品在响应 items 中的下标
   * @param {Array<{variantId: string, quantity: number}>} requestedItems - 请求体解析结果
   * @returns {{variantId: string, quantity: number}|null} 匹配到的本次请求商品
   */
  function getRequestedItem(responseItem, responseIndex, requestedItems) {
    const responseVariantId = String(responseItem.variant_id || responseItem.id);
    const indexedItem = requestedItems[responseIndex];

    if (indexedItem && indexedItem.variantId === responseVariantId) {
      return indexedItem;
    }

    return requestedItems.find(item => item.variantId === responseVariantId) || null;
  }

  /**
   * 获取用于埋点的折后单价，单位为 Shopify 的最小货币单位（例如美分）。
   * discounted_price 包含更多已分摊折扣，因此优先级为：
   * discounted_price -> final_price -> price。
   * @param {Object} item - Shopify 购物车行项目
   * @returns {number} 折后单价（分）；无法解析时返回 0
   */
  function getDiscountedPriceInCents(item) {
    const price = item.discounted_price ?? item.final_price ?? item.price;
    const numericPrice = Number(price);
    return Number.isFinite(numericPrice) ? numericPrice : 0;
  }

  /**
   * 获取当前购物车展示币种。
   * 优先使用接口响应币种，其次使用主题和 Shopify 全局币种，最后兜底 USD。
   * @param {Object} cartData - 购物车或加购响应数据
   * @returns {string} ISO 货币代码，例如 USD
   */
  function getCartCurrency(cartData = {}) {
    return cartData.currency
      || window.themeVariables?.settings?.cartCurrency
      || window.Shopify?.currency?.active
      || window.shopCurrency
      || 'USD';
  }

  /**
   * 判断加购来源
   * @param {string} url - 请求 URL
   * @param {HTMLElement} capturedButton - 在请求发起时捕获的按钮元素
   * @returns {string} 加购来源枚举值
   */
  function determineAddSource(url, capturedButton = null) {
    // 1. 优先检查 URL 参数（最可靠）
    if (url.includes('src=selleasy')) return 'selleasy_upsell';
    if (url.includes('src=cart_recommend')) return 'cart_recommend';

    // 2. 使用在请求发起时捕获的按钮（最准确）
    let button = capturedButton;

    // 3. 如果没有捕获到按钮，尝试从当前活跃元素获取（兜底）
    if (!button) {
      const activeElement = document.activeElement;
      button = activeElement?.tagName === 'BUTTON' ? activeElement : activeElement?.closest('button');
    }

    if (button) {
      // ⚠️ 注意：判断顺序很重要！从具体到通用
      // 2. 快速查看弹窗
      if (button.closest('quick-buy-drawer') || button.closest('quick-buy-popover')) {
        return 'quick_add';
      }

      // 1. 最具体：购物车推荐（内部也是 product-item，必须先判断）
      if (button.closest('.mini-cart__recommendations')) {
        return 'cart_recommend';
      }

      // 3. 商品列表（最通用，最后判断）
      if (button.closest('.product-item')) {
        // 判断当前页面是否是网站首页
        if (window.location.pathname === '/') {
          return 'home_collection_add';
        }
        return 'collection_add';
      }

      // 检查按钮的表单位置
      const form = button.closest('form');
      if (form?.closest('[data-section-type="main-product"]')) {
        return 'pdp_main_button';
      }
    }

    // 3. 通过页面 URL 判断（兜底方案）
    if (window.location.pathname.includes('/products/')) {
      return 'pdp_main_button';
    }

    // 4. 购物车页面加购
    if (window.location.pathname.includes('/cart')) {
      return 'cart_recommend';
    }

    return 'other_add';
  }

  /**
   * 推送加购事件到 GA4
   * @param {Object} cartData - /cart/add.js 的响应数据
   * @param {string} addSource - 加购来源枚举值
   */
  async function pushAddToCartEvent(cartData, addSource, capturedContext, requestedItems = []) {
    try {
      // 1. 提取商品信息（处理两种响应格式）
      let addedItem = null;

      // 格式1：Selleasy 插件等，返回 items 数组
      if (cartData.items && Array.isArray(cartData.items) && cartData.items.length > 0) {
        addedItem = cartData.items;
      }
      // 格式2：普通加购，直接返回商品对象
      else if (cartData.product_title || cartData.title) {
        addedItem = [cartData];
      }

      if (!addedItem) {
        return;
      }

      // 2. 为每个商品构建 GA4 标准的 item 对象
      const ga4Items = addedItem.map((item, index) => {
        const requestedItem = getRequestedItem(item, index, requestedItems);
        const ga4Item = {
          item_id: (item.variant_id || item.id).toString(),
          item_name: item.product_title || item.title,
          price: formatPrice(getDiscountedPriceInCents(item)),
          quantity: requestedItem ? requestedItem.quantity : 1,
          item_category: item.product_type || 'Uncategorized',
          item_variant: item.variant_title || 'Default Title',
          item_sku: item.sku || '',
        };

        return ga4Item;
      });

      // 获取item_list_name
      let listName = "unknown_list";
      if (capturedContext) {
        listName = capturedContext.listName;
      }

      // 3. 计算总金额（所有商品的 price × quantity 之和）
      let totalValue = ga4Items.reduce((sum, item) => {
        return sum + (item.price * item.quantity);
      }, 0);
      // totalValue去浮点
      totalValue = Math.round(totalValue * 100) / 100;

      // 4. 获取币种
      const currency = getCartCurrency(cartData);

      // 5. 构建 GA4 事件对象
      const event = {
        event: "add_to_cart",
        add_source: addSource,
        ecommerce: {
          currency: currency,
          value: totalValue,
          item_list_name: listName,
          items: ga4Items
        }
      };

      await storeGAIdsToCart() // 写入client_id

      // 6. 推送到 dataLayer
      dataLayer.push(event);

    } catch (error) {
      console.error('[Analytics] Failed to push add_to_cart event:', error);
    }
  }

  /**
   * 初始化加购事件拦截
   */
  function initCartInterception() {
    // 最近点击的按钮记录（用于快速连续点击场景）
    let recentButtonClicks = [];

    // 监听所有按钮点击，记录加购按钮
    document.addEventListener('click', (event) => {
      const button = event.target.tagName === 'BUTTON'
        ? event.target
        : event.target.closest('button');

      if (!button) return;


      // 1. 尝试从 DOM 容器获取（列表页/推荐位/Quick View 逻辑）
      const productEl = button.closest("[data-item-id]");
      if (productEl) {
        const item = getProductData(productEl);
        lastInteractedContext = {
          id: item.items.item_id,
          listName: item.item_list_name
        };
      }
      // 2. 如果没找到容器，且当前在详情页，使用页面级上下文（PDP 加购逻辑）
      else if (location.pathname.includes("/products/")) {
        lastInteractedContext = {
          id: pageLevelContext.itemId,
          listName: pageLevelContext.listName
        };
      }

      // 检查是否是加购相关的按钮
      const form = button.closest('form');
      const isAddToCartButton =
        button.type === 'submit' ||
        button.classList.contains('product-item__quick-buy-button') ||
        button.closest('.product-item__quick-form') ||
        (form && form.action && form.action.includes('/cart/add'));

      if (isAddToCartButton) {
        // 记录到最近点击列表（使用时间戳）
        recentButtonClicks.push({
          button: button,
          timestamp: Date.now()
        });

        // 只保留最近 3 秒的点击记录
        recentButtonClicks = recentButtonClicks.filter(
          click => Date.now() - click.timestamp < 3000
        );

        // 3秒后清理（防止内存泄漏）
        setTimeout(() => {
          // 从最近点击列表中移除这个按钮
          const index = recentButtonClicks.findIndex(click => click.button === button);
          if (index !== -1) {
            recentButtonClicks.splice(index, 1);
          }
        }, 3000);
      }
    }, true); // 使用捕获阶段，确保最先执行

    // 拦截 Fetch API
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const [resource, options] = args;
      const url = getRequestUrl(resource);

      // 检查是否是加购请求
      if (url.includes('/cart/add.js')) {
        // --- 捕获当前的上下文快照 ---
        const capturedContext = lastInteractedContext ? { ...lastInteractedContext } : null;
        const requestedItemsPromise = getFetchRequestedItems(resource, options);

        // ✅ 修复：在请求发起时，从最近点击列表中获取最相关的按钮
        const now = Date.now();

        // 优先查找最近 500ms 内的点击
        let capturedButton = recentButtonClicks
          .filter(click => now - click.timestamp < 500)
          .sort((a, b) => b.timestamp - a.timestamp)[0]?.button;

        // 如果没有找到，尝试查找最近 1 秒内的点击
        if (!capturedButton) {
          capturedButton = recentButtonClicks
            .filter(click => now - click.timestamp < 1000)
            .sort((a, b) => b.timestamp - a.timestamp)[0]?.button;
        }

        return originalFetch.apply(this, args).then(response => {
          // 克隆响应（因为响应流只能读取一次）
          const clonedResponse = response.clone();

          // 请求成功后触发埋点
          if (response.ok) {
            clonedResponse.json().then(async cartData => {
              const requestedItems = await requestedItemsPromise;
              const addSource = determineAddSource(url, capturedButton);
              pushAddToCartEvent(cartData, addSource, capturedContext, requestedItems);
            }).catch(err => {
              console.error('[Analytics] Failed to parse cart response:', err);
            });
          }

          return response;
        });
      }

      return originalFetch.apply(this, args);
    };

    // 拦截 XMLHttpRequest（兼容旧代码）
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this._analyticsUrl = getRequestUrl(url);
      // --- 关键修改：在 open 时将当前上下文绑定到 XHR 实例 ---
      this._capturedContext = lastInteractedContext ? { ...lastInteractedContext } : null;

      // ✅ 修复：在请求发起时，从最近点击列表中获取最相关的按钮
      const now = Date.now();

      // 优先查找最近 500ms 内的点击
      let capturedButton = recentButtonClicks
        .filter(click => now - click.timestamp < 500)
        .sort((a, b) => b.timestamp - a.timestamp)[0]?.button;

      // 如果没有找到，尝试查找最近 1 秒内的点击
      if (!capturedButton) {
        capturedButton = recentButtonClicks
          .filter(click => now - click.timestamp < 1000)
          .sort((a, b) => b.timestamp - a.timestamp)[0]?.button;
      }

      this._analyticsElement = capturedButton;

      return originalOpen.apply(this, [method, url, ...rest]);
    };

    XMLHttpRequest.prototype.send = function(body) {
      const xhr = this;
      xhr._analyticsRequestedItems = parseAddRequestBody(body);

      // 监听请求完成
      xhr.addEventListener('loadend', function() {
        if (xhr._analyticsUrl && xhr._analyticsUrl.includes('/cart/add.js') && xhr.status === 200) {
          try {
            const cartData = JSON.parse(xhr.responseText);
            const addSource = determineAddSource(xhr._analyticsUrl, xhr._analyticsElement);
            pushAddToCartEvent(
              cartData,
              addSource,
              this._capturedContext,
              xhr._analyticsRequestedItems
            );
          } catch (error) {
            console.error('[Analytics] Failed to process XHR cart response:', error);
          }
        }
      });

      return originalSend.apply(this, arguments);
    };
  }


  // 处理购物车页面不调add的加购事件
  // 从 sessionStorage 读取上次的购物车状态（页面刷新后保持）
  let previousCart = sessionStorage.getItem('analyticsPreviousCart')
    ? JSON.parse(sessionStorage.getItem('analyticsPreviousCart'))
    : null;

  async function detectAddToCartOnLoad() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (!previousCart) {
        // 持久化到 sessionStorage，页面刷新后可读取
        sessionStorage.setItem('analyticsPreviousCart', JSON.stringify(cart));
        return;
      }

      // 找新增或数量增加的商品
      cart.items.forEach(item => {
        const oldItem = previousCart.items.find(i => i.key === item.key);

        if (!oldItem) {
          // 新商品
          triggerAddEvent(item);
        } else if (item.quantity > oldItem.quantity) {
          // 数量增加  暂时不记录
          // triggerAddEvent({
          //   ...item,
          //   quantity: item.quantity - oldItem.quantity
          // });
        }
      });

      previousCart = cart;
      // 同步更新 sessionStorage
      sessionStorage.setItem('analyticsPreviousCart', JSON.stringify(cart));

    } catch (e) {
      console.error('cart 检测失败', e);
    }
  }

  async function triggerAddEvent(item) {
    await storeGAIdsToCart() // 写入client_id
    window.dataLayer = window.dataLayer || [];
    const itemPrice = formatPrice(getDiscountedPriceInCents(item));

    dataLayer.push({
      event: 'add_to_cart',
      add_source: 'cart_recommend', // 👈 这里你可以标记来源
      ecommerce: {
        currency: getCartCurrency(item),
        value: Math.round(itemPrice * item.quantity * 100) / 100,
        items: [{
          item_id: item.variant_id.toString(),
          item_sku: item.sku || '',
          item_name: item.product_title,
          price: itemPrice,
          quantity: item.quantity
        }]
      }
    });
  }

  // 5.开始结账埋点
  function buildCheckoutItems(cart) {

    if (!cart || !cart.items) return [];

    return cart.items.map(item => {

      return {
        item_id: (item.variant_id || item.id).toString(),
        item_name: item.product_title || item.title,
        price: formatPrice(getDiscountedPriceInCents(item)),
        quantity: item.quantity,
        item_category: item.product_type || 'Uncategorized',
        item_variant: item.variant_title || 'Default Title'
      };

    });

  }

  function getCouponCode(cart) {

    // Shopify 标准字段
    if (cart.discount_codes && cart.discount_codes.length > 0) {
      return cart.discount_codes[0].code;
    }

    // 有些主题存在 input
    const input = document.querySelector('[name="discount"]');
    if (input && input.value) return input.value;

    return "";

  }

  function pushBeginCheckout(cart) {
    try {

      const items = buildCheckoutItems(cart);

      if (!items.length) return;

      const totalValue = formatPrice(cart.total_price);

      const currency = cart.currency || window.shopCurrency || 'USD';

      const coupon = getCouponCode(cart);

      const event = {
        event: "begin_checkout",
        ecommerce: {
          currency: currency,
          value: totalValue,
          coupon: coupon,
          items: items
        }
      };

      dataLayer.push(event);

    } catch (error) {
      console.error('[Analytics] begin_checkout error:', error);
    }

  }

  function fetchCartAndSend() {

    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        pushBeginCheckout(cart);
      })
      .catch(err => {
        console.error('[Analytics] cart fetch failed:', err);
      });

  }

  function isCheckoutButton(el) {
    if (!el) return false;

    // Shopify 常见 checkout 入口
    return (
      el.matches('button[name="checkout"]') ||
      el.matches('input[name="checkout"]') ||
      el.closest('form[action="/checkout"]') ||
      el.href?.includes('/checkout')
    );

  }

  function initBeginCheckout() {

    document.addEventListener('click', function (event) {

      const el = event.target.closest('button, a, input');

      if (!isCheckoutButton(el)) return;

      // ⚠️ 关键：先发埋点，再跳转
      fetchCartAndSend();

    }, true);

  }

  // 获取client_id和session_id
  function getClientId() {
    const gaCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('_ga='));
    if (!gaCookie) return null;
    const parts = gaCookie.split('=')[1].split('.');
    return parts[2] + '.' + parts[3];
  }

  function getSessionId(measurementId) {
    const cookieName = '_ga_' + measurementId.replace('G-', '');

    const gsCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith(cookieName + '='));

    if (!gsCookie) return null;

    const value = decodeURIComponent(gsCookie.split('=')[1]);

    // 新格式：s1778226636$o28$...
    const newFormat = value.match(/s(\d+)\$/);
    if (newFormat) return newFormat[1];

    // 旧格式：GS1.1.1778226636.1.1...
    if (value.startsWith('GS1.')) {
      return value.split('.')[2];
    }

    return null;
  }

  function storeGAIdsToCart() {
    const measurementId = 'G-3JCL4R70TD'; // 换成你们真实的 ID

    const clientId = getClientId();
    const sessionId = getSessionId(measurementId);

    if (!clientId || !sessionId) {
      console.warn('[GA4] cookie 未就绪，500ms 后重试');
      setTimeout(storeGAIdsToCart, 500);
      return;
    }

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const existingAttributes = cart.attributes || {};
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              ...existingAttributes,
              _ga_client_id: clientId,
              _ga_session_id: sessionId,
            }
          })
        });
      })
      .then(res => res.json())
      .then(cart => {
        console.log('[GA4] 写入成功，cart attributes:', cart.attributes);
      })
      .catch(err => {
        console.error('[GA4] 写入失败:', err);
      });
  }

  document.addEventListener("DOMContentLoaded", () => {
    // 初始化曝光及点击
    initExposure();
    initClick();
    
    // 初始化商品详情浏览
    initProductDetail();
    initQuickViewObserver();

    // 初始化加购事件追踪
    initCartInterception();

    // 初始化开始结账
    initBeginCheckout();

    const isFromCart = document.referrer.includes('/cart') && window.location.pathname.includes('/cart');
    if(isFromCart) {
      detectAddToCartOnLoad()
    }

  });

  document.addEventListener('change', function (event) {
    var swatch = event.target.closest('.product-item-meta__swatch-list .color-swatch__radio');
    if (!swatch) return;

    var productItem = swatch.closest('product-item');
    var samitaVariant = productItem.querySelector('.samita-variant');

    if (samitaVariant) {
      samitaVariant.value = swatch.dataset.variantId;
    }
  });

})();
